import { Card } from "@mantine/core";
import { useHover } from "@mantine/hooks";

export function GalleryVideoCard({ image, onClick, selectionMode }) {
  const { ref } = useHover();

  return (
    <Card
      withBorder
      shadow="sm"
      radius="md"
      pb={0}
      onClick={() => {
        selectionMode ? false : onClick();
      }}
      style={{ cursor: "pointer" }}
      ref={ref}
    >
      <Card.Section>
        <video width="100%" height="auto" controls>
          <source src={image.videoUrl} type="video/mp4" />
        </video>
      </Card.Section>
    </Card>
  );
}
